export default __webpack_public_path__ + "static/media/element_5.343136e1.jpg";